
<template>
  <div >
    <v-alert type="info" v-if="loading" :value="true" class="ma-3">
      Carregando resumo financeiro...
      <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
    </v-alert>
    <v-row  class="d-flex justify-space-around flex-wrap" v-if="!loading">

      <v-col cols="12" sm="auto" md="auto" lg="2" class="pa-0 mt-2 mx-2">
        <v-card class="ma-0 elevation-1 d-flex flex-column" min-height="140px">
          <v-card-title class="title text-start primary darken-2 white--text py-1">Cheques
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-note</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left">
              <span>Custódia:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(checks.hold).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
            </div>
  
            <div class="text-xs-left">
              <span>Devolvidos:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(checks.returned).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="auto" md="auto" lg="2" class="pa-0 mt-2 mx-2">
        <v-card class="ma-0 elevation-1 d-flex flex-column" min-height="140px">
          <v-card-title class="title text-start primary darken-2 white--text py-1">Faturas
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-swap-horizontal</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left">
              <span>Pedidos em andamento:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(transactions.open_orders).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}}
              </span>
            </div>
            <div class="text-xs-left">
              <span>Em aberto:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(transactions.open).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}}
              </span>
            </div>
            <div class="text-xs-left">
              <span>Atrasadas:</span>
              <span :class="transactions.overdue > 0 ? 'font-weight-bold ml-1 red--text' : 'font-weight-bold ml-1 black--text'">{{
                Number(transactions.overdue).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="auto" md="auto" lg="2" class="pa-0 mt-2 mx-2">
        <v-card class="ma-0 elevation-1 d-flex flex-column" min-height="140px">
          <v-card-title class="title text-start primary darken-2 white--text py-1">Crédito
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-credit-card</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left">
              <span class="d-block">Disponível / Limite original:</span>
              <div class="font-weight-bold ml-1 black--text">
                <span>{{ Number(credit.limit).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
                <span class="mx-1">/</span>
                <span>{{Number(credit.original_limit).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</span>
              </div>
            </div>
  
            <div class="text-xs-left">
              <span class="d-block">Bônus:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(credit.bonus).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="auto" md="auto" lg="2" class="pa-0 mt-2 mx-2">
        <v-card class="ma-0 elevation-1 d-flex flex-column" min-height="140px">
          <v-card-title class="title text-start primary darken-2 white--text py-1">Boletos
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-barcode</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
  
            <div class="text-xs-left">
              <span>Abertos:</span>
              <span class="font-weight-bold ml-1 black--text">{{
                Number(bills.open).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
            </div>
  
            <div class="text-xs-left">
              <span>Atrasados:</span>
              <span :class="bills.overdue > 0 ? 'font-weight-bold ml-1 red--text' : 'font-weight-bold ml-1 black--text'">{{
                Number(bills.overdue).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
              </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="auto" md="auto" lg="2" class="pa-0 mt-2 mx-2">
        <v-card class="ma-0 elevation-1 d-flex flex-column" min-height="140px">
          <v-card-title class="title text-start primary darken-2 white--text py-1">Prazo Médio
            <v-spacer></v-spacer>
            <v-icon class="white--text">mdi-calendar-range</v-icon>
          </v-card-title>
          <v-card-text class="mt-0 d-flex align-center flex-column flex-fill justify-center py-0 mt-0 ">
            <div class="text-xs-left">
              <span>7 dias:</span>
              <span class="font-weight-bold ml-1 black--text">{{ avg_sale_period.week }}</span>
            </div>
  
            <div class="text-xs-left">
              <span>Mensal:</span>
              <span class="font-weight-bold ml-1 black--text">{{ avg_sale_period.month }}</span>
            </div>
  
            <div class="text-xs-left">
              <span>Anual:</span>
              <span class="font-weight-bold ml-1 black--text">{{ avg_sale_period.year }}</span>
            </div>
  
            <div class="text-xs-left">
              <span>Todo período:</span>
              <span class="font-weight-bold ml-1 black--text">{{ avg_sale_period.beginning }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ProfileFinancialAndPayments',
  props: {
    client_id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      loading: false,
      // payments: {
      //   deposits: {
      //     ammount_blocked: 0,// '22666.55',
      //   },
      //   envelopes: {
      //     ammount_blocked: 0,// '22666.55',
      //   }
      // },
      transactions: {
        overdue: 0,// '22666.55',
        overdue_unblock: 0,// '22666.55',
        open: 0,// '22666.55',
        open_unblock: 0,// '22666.55',
        open_orders: 0,// '22666.55',
      },
      bills: {
        open: 0,// '22666.55',
        overdue: 0,// '22666.55',
      },
      checks: {
        hold: 0,
        returned: 0,
      },
      credit: {
        bonus: 0,
        limit: 0
      },
      info: {
      },
      avg_sale_period: {
        month: "Sem Vendas",
        year: "Sem Vendas"
      }
    }
  },
  methods: {
    getData() {
      this.loading = true
      Api.Client.indexPaymentsResume(this.client_id || this.one_client_id).then(r => r.data).then(d => {
        // console.log({d});
        // this.payments = { ...d.payments }
        this.transactions = { ...d.transactions }
        this.bills = { ...d.bills }
        this.checks = { ...d.checks }
        this.credit = { ...d.credit }
        this.avg_sale_period = { ...d.avg_sale_period }
        setTimeout(() => {
          this.loading = false
        }, 1200);
      })
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted() {
    this.getData();
  },
  computed: {
    one_client_id() {
      if (this.oneClient) {
        return this.oneClient.data.attributes.id
      }
      return null
    },
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch: {
    data(nv, ov) {
      if (nv) {
      } else if (nv == false) {
      }
    }
  },
}
</script>

<style scoped>

.custom-grid .v-col {
  max-width: calc(100% / 10) !important; /* Define o máximo de 10 colunas */
  flex: 0 0 calc(100% / 10) !important; /* Altera o comportamento do flex */
}
>>> .custom-grid .v-col {
  max-width: calc(100% / 10) !important;;
  flex: 0 0 calc(100% / 10) !important;;
}

</style>
